import angular from "angular";

let TimeTitleListController = function (
  TimeTitleService,
  $mdDialog,
  $filter,
  $scope,
  $state,
  Toast
) {
  let $ctrl = this;
  $ctrl.$scope = $scope;
  angular.extend($ctrl, {
    getTimeTitleList,
    modalTitle,
    removeTitle,
  });

  activate();

  function activate() {
    $ctrl.promise;
    $ctrl.timeTitles = [];
    $ctrl.totalItems = 0;
    $ctrl.filter = {
      limit: 10,
      page: 1,
      title: ""
    };
    getTimeTitleList();
  }

  function getTimeTitleList() {
    const filter = angular.copy($ctrl.filter)
    if(!$ctrl.filter.title) delete filter.title
    $ctrl.uiState = "LOADING";
    $ctrl.promise = TimeTitleService.getTimeTitleList(filter)
      .then((response) => {
        $ctrl.timeTitles = angular.copy(response.data);
        $ctrl.totalItems = response.total;
      })
      .catch((err) => {})
      .finally(() => {
        $ctrl.uiState = "COMPLETE";
      });
  }

  function modalTitle(data = null) {
    $mdDialog
      .show({
        controller: DialogController,
        template:
          '<md-dialog aria-label="Version dialog" style="width: 400px; padding: 24px;">' +
          "  <md-dialog-content>" +
          "     <h4><strong>Título de horário de funcionamento</strong></h4>" +
          "     <div>Insira o título do horário de funcionamento</div>" +
          '     <div style="padding-top: 24px;">' +
          '       <md-input-container class="md-block" flex style="width: 99%;">' +
          "       <label>Título do horário*</label>" +
          '       <input ng-model="data.title" name="title">' +
          "      </md-input-container>" +
          "     </div>" +
          "     <div> </div>" +
          "</md-dialog-content>" +
          "<md-dialog-actions>" +
          '  <md-button ng-click="cancel()">Cancelar</md-button>' +
          '  <md-button ng-click="save()" ng-disabled="!data.title || loading" class="md-raised md-accent">Salvar</md-button>' +
          "  </md-dialog-actions>" +
          "</md-dialog>",
        bindToController: true,
        parent: angular.element(document.body),
        locals: { data },
        clickOutsideToClose: true,
        fullscreen: false,
      })
      .then(
        function () {
          getTimeTitleList();
        },
        function () {}
      );
  }

  function removeTitle(data) {
    $mdDialog
      .show({
        controller: DialogController,
        template:
          '<md-dialog aria-label="Version dialog" style="width: 400px; padding: 24px;">' +
          "  <md-dialog-content>" +
          "     <h4><strong>Excluir título de horário de funcionamento</strong></h4>" +
          "     <div class='subtitle'>Tem certeza que deseja excluir este título?</div>" +
          '     <div class="title-name">{{data.title}}</div' +
          "</md-dialog-content>" +
          "<md-dialog-actions>" +
          '  <md-button ng-click="cancel()">Cancelar</md-button>' +
          '  <md-button ng-click="delete()" ng-disabled="!data.title || loading" class="md-raised md-accent">Excluir</md-button>' +
          "  </md-dialog-actions>" +
          "</md-dialog>",
        bindToController: true,
        parent: angular.element(document.body),
        locals: { data },
        clickOutsideToClose: true,
        fullscreen: false,
      })
      .then(
        function () {
          getTimeTitleList();
        },
        function () {}
      );
  }

  function DialogController($scope, $mdDialog, data) {
    "ngInject";
    $scope.data = {
      title: "",
    };
    if (data) {
      $scope.data = angular.copy(data);
    }
    $scope.loading = false;

    $scope.hide = function () {
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.delete = function () {
      $scope.loading = true;
      $ctrl.promise = TimeTitleService.destroy($scope.data)
        .then(() => {
          $mdDialog.hide();
        })
        .catch((err) => {})
        .finally(() => {
          $scope.loading = false;
        });
    };

    $scope.save = function () {
      $scope.loading = true;
      $ctrl.promise = TimeTitleService.save($scope.data)
        .then((response) => {
          $mdDialog.hide();
        })
        .catch((err) => {})
        .finally(() => {
          $scope.loading = false;
        });
    };
  }
};

TimeTitleListController.$inject = [
  "TimeTitleService",
  "$mdDialog",
  "$filter",
  "$scope",
  "$state",
  "Toast",
];

export default TimeTitleListController;



// WEBPACK FOOTER //
// ./client/app/components/title-time/time-title-list.controller.js